module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./widget.js"));
	}, "widget");
}